<template>
    <div>
      <v-card>
  
        <v-card-title><span class="pink--text">Education & Carrers</span>
          <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
        <v-form @submit.prevent="submitForm" class="pa-2">
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.qualifications" multiple :items="LookupArr(dropDownList?.qualificationList)"
              item-text="text" item-value="value" label="Qualification"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.annualIncome" multiple  :items="LookupArr(dropDownList?.annualIncomeList)"
              item-text="text" item-value="value" label="Annual Income "></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.profession" multiple  :items="LookupArr(dropDownList?.role)"
              item-text="text" item-value="value" label="working with"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.employmentType" multiple :items="LookupArr(dropDownList?.workingAs)"
              item-text="text" item-value="value" label="working as"></v-autocomplete>
            </v-col>
           
            <v-col cols="12" md="12" class="d-flex justify-end">
              <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        Indicator:"carrer"
      };
    },
    props: {
      partnerpreference:{},partnerpreferenceList:[],dropDownList:{}
    },
    methods:{
  submitForm() {
this.$emit("carrer", this.Indicator)
// Handle form submission logic here, e.g., send data to an API or update the state
},
}

  };
  </script>
  